"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsLocked_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var PlayerMultiaccountsListByPassword = /** @class */ (function (_super) {
    __extends(PlayerMultiaccountsListByPassword, _super);
    function PlayerMultiaccountsListByPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Игрок',
                dataIndex: _this.props.dataMultiaccounts.dk_login,
                key: _this.props.dataMultiaccounts.dk_login,
                width: 200,
            }, {
                title: 'Добавлено',
                dataIndex: _this.props.dataMultiaccounts.dk_date_added,
                key: _this.props.dataMultiaccounts.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Почта',
                dataIndex: _this.props.dataMultiaccounts.dk_email,
                key: _this.props.dataMultiaccounts.dk_email,
                width: 200,
            }, {
                title: 'Пароль',
                dataIndex: _this.props.dataMultiaccounts.dk_password,
                key: _this.props.dataMultiaccounts.dk_password,
                width: 200,
            }, {
                title: 'Геоданные',
                dataIndex: _this.props.dataMultiaccounts.dk_by_ip_city,
                key: _this.props.dataMultiaccounts.dk_by_ip_city,
                render: function (text, record, index) {
                    return (React.createElement("span", null,
                        record.by_ip_country_code,
                        ".",
                        record.by_ip_city,
                        ".",
                        record.by_ip_organisation));
                },
                width: 200,
            }, {
                title: 'Кол-во д/с',
                dataIndex: _this.props.dataMultiaccounts.dk_deposits_count,
                key: _this.props.dataMultiaccounts.dk_deposits_count,
                render: function (text, record, index) {
                    return (React.createElement("span", null,
                        record.deposits_count,
                        "/",
                        record.withdraws_count));
                },
                width: 200,
            }, {
                title: 'Сумма д/с',
                dataIndex: _this.props.dataMultiaccounts.dk_withdraws_amount,
                key: _this.props.dataMultiaccounts.dk_withdraws_amount,
                render: function (text, record, index) {
                    return (React.createElement("span", null,
                        record.deposits_amount,
                        "/",
                        record.withdraws_amount));
                },
                width: 200,
            }, {
                title: 'Оффсет, час',
                dataIndex: _this.props.dataMultiaccounts.dk_time_zone_offset_hours,
                key: _this.props.dataMultiaccounts.dk_time_zone_offset_hours,
                width: 200,
            }, {
                title: 'Партнер',
                dataIndex: _this.props.dataMultiaccounts.dk_partner_login,
                key: _this.props.dataMultiaccounts.dk_partner_login,
                width: 200,
            }, {
                title: 'Заблокирован',
                dataIndex: _this.props.dataMultiaccounts.dk_is_locked,
                key: _this.props.dataMultiaccounts.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать игрока", text: "Да" }, unlockedTexts: { menu: "Разблокировать игрока", text: "Нет" }, record: { key: record.key, title: record.login, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Игровая зона',
                dataIndex: _this.props.dataMultiaccounts.dk_custom_zone_title,
                key: _this.props.dataMultiaccounts.dk_custom_zone_title,
                width: 200,
            }
        ];
        return _this;
    }
    PlayerMultiaccountsListByPassword.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    PlayerMultiaccountsListByPassword.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataMultiaccounts.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFormat: data.dtTimeFormat,
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: [],
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
    };
    PlayerMultiaccountsListByPassword.prototype.componentWillUnmount = function () {
        this.props.dataMultiaccounts.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PlayerMultiaccountsListByPassword.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    PlayerMultiaccountsListByPassword.prototype.loadData = function (Props, onDone) {
        Props.dataMultiaccounts.LoadAllDataByPassword(Props.player.key, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    PlayerMultiaccountsListByPassword.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.dataMultiaccounts.SetPlayerIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u043E\u043A ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u043E\u043A ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PlayerMultiaccountsListByPassword.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PlayerMultiaccountsListByPassword.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "create") {
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PlayerMultiaccountsListByPassword.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A:"),
                            " [",
                            _this.props.player.login,
                            "]")));
                }, scroll: { x: true } })));
    };
    return PlayerMultiaccountsListByPassword;
}(React.Component));
exports.default = PlayerMultiaccountsListByPassword;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/multiaccounts/PlayerMultiAccountsListByPassword.tsx
// module id = 1945
// module chunks = 0